// extracted by mini-css-extract-plugin
module.exports = {"subscription":"styles_subscription__ZAimE"};